import React from 'react';
import * as LucideIcons from 'lucide-react';
import { useAppContext } from '../AppContext';
import { useTranslation } from 'react-i18next';

// Function to generate a gradient from a string seed (entry.id)
const generateGradient = (seed) => {
    let hash = 0;
    for (let i = 0; i < seed.length; i++) {
        hash = seed.charCodeAt(i) + ((hash << 5) - hash);
    }

    const h = hash % 360;
    const s = 70; // Keep saturation high for vibrant colors
    const l1 = 40; // Darker start
    const l2 = 60; // Lighter end

    const angle = (hash % 180) + 45; // Randomize angle

    return `linear-gradient(${angle}deg, hsl(${h}, ${s}%, ${l1}%), hsl(${(h + 40) % 360}, ${s}%, ${l2}%))`;
};

const LotteryTicket = ({ entry, isWinningTicket = false, isMyTicket = false, justPurchasedTicketId = null, totalPot, photoURL }) => {
  const { handleOpenCreateModalWithText } = useAppContext();
  const { t } = useTranslation();
  const purchaseDate = entry.timestamp?.toDate().toLocaleString() || t('lotteryTicket.notAvailable');
  const isJustPurchased = justPurchasedTicketId === entry.id;
  const totalTickets = (entry.amount || 0) + (entry.bonusTickets || 0);

  const handleShare = () => {
    const shareMessage = t('lotteryTicket.shareMessage', { totalTickets: totalTickets.toLocaleString(), totalPot: totalPot.toLocaleString() });
    handleOpenCreateModalWithText(shareMessage);
  };

  const backgroundGradient = generateGradient(entry.id);

  return (
    <div 
        className={`relative p-4 rounded-xl shadow-lg border transition-all duration-300 overflow-hidden 
                    ${isWinningTicket ? 'border-yellow-400 animate-pulse-slow' : 'border-gray-700/50'} 
                    ${isJustPurchased ? 'animate-new-ticket' : ''}`}
        style={{ background: backgroundGradient }}
    >
        <div className="absolute inset-0 bg-black/30 mix-blend-multiply" />
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-20" />

        {isMyTicket && !isWinningTicket && (
            <button onClick={handleShare} className="absolute top-2 right-2 text-gray-300 hover:text-white transition-colors z-10">
                <LucideIcons.Share2 size={16} />
            </button>
        )}
        {isWinningTicket && (
            <LucideIcons.Crown size={24} className="absolute top-2 right-2 text-yellow-300 animate-bounce z-10" aria-label={t('lotteryTicket.winningTicket')} />
        )}

        <div className="relative z-10">
            <div className="flex items-center gap-3 mb-3">
                <img src={photoURL} alt={t('lotteryTicket.avatarAlt')} className="w-10 h-10 rounded-full border-2 border-white/50"/>
                <div>
                    <p className="font-bold text-lg text-white">{t('lotteryTicket.tickets', { count: totalTickets })}</p>
                    <p className="text-xs text-gray-300">{t('lotteryTicket.id', { id: entry.id.substring(0, 8) })}</p>
                </div>
            </div>
            
            <div className="text-right">
                <span className="text-xs text-gray-200 bg-black/20 px-2 py-1 rounded-md">{t('lotteryTicket.purchased', { date: purchaseDate })}</span>
            </div>
        </div>
    </div>
  );
};

export default LotteryTicket;